import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { UserInstructionsLLMComponent } from './user-instructions-llm.component';

const ROUTES: Routes = [
  { path: 'user-instructions-llm', component: UserInstructionsLLMComponent, pathMatch: 'full' },
];

@NgModule({ imports: [
  BrowserModule,
  FormsModule,
  RouterModule.forChild(ROUTES),
],
declarations: [UserInstructionsLLMComponent],
exports: [UserInstructionsLLMComponent] })
export class UserInstructionsLLMModule {}
